import { createConnection } from '@thom/pb/realtime'
import type { ConnectionPort } from '@thom/folio-domain/core/ports/connection'
import { createEmitter } from '@thom/folio-domain/lib/emitter'
import { getPocketBaseClient } from './client'

type ConnectTopic = {
	readonly subscribe: (topic: string, handler: () => void) => Promise<unknown>
	onDisconnect?: (activeSubscriptions: string[]) => void
}

const createConnectionAdapter = (realtime?: ConnectTopic): ConnectionPort => {
	const source = realtime ?? getPocketBaseClient().realtime
	const statuses = createEmitter<boolean>()
	const retries = createEmitter()

	source.onDisconnect = activeSubscriptions => {
		if (activeSubscriptions.length > 0) statuses.emit(false)
	}

	const connection = createConnection(source)
	connection.onConnect(() => statuses.emit(true))

	return {
		onReconnect: listener => {
			const stops = [connection.onReconnect(listener), retries.on(listener)]

			return () => {
				for (const stop of stops) stop()
			}
		},
		onStatusChange: statuses.on,
		retry: () => retries.emit(),
	}
}

export { createConnectionAdapter }
